import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext.jsx';
import {
  markOpenedBriefToday,
  shouldRedirectAuthenticatedToToday,
} from '../../lib/dailyLanding.js';
import { hasSeenWelcome } from '../../lib/firstVisit.js';
import Home from './Home.jsx';

export default function Landing() {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center py-24 text-hxd-muted text-sm">
        Loading…
      </div>
    );
  }

  // First-time unauthenticated visitors get the standalone /welcome takeover.
  // After they dismiss it (Proceed / Subscribe both call markWelcomeSeen),
  // future visits to / fall through to Home — so clicking the Home nav link
  // shows the actual Home page rather than re-bouncing them to /welcome.
  if (!isAuthenticated && !hasSeenWelcome()) {
    return <Navigate to="/welcome" replace />;
  }

  // Authed users may be auto-redirected to /today on first visit of the day.
  if (isAuthenticated && shouldRedirectAuthenticatedToToday()) {
    markOpenedBriefToday();
    return <Navigate to="/today" replace />;
  }

  return <Home />;
}
